export default class Validator {
    constructor() {
        this.decimalSeparator = '.';
    }

    zipcode(value) {
        return !!(value.match(/^((1[1-9])|(2[0-8])|(3[0-46-9])|(4[0-9])|(5[0-36-9])|(6[0-47-9])|(7[0-689])|(8[0-5]))[0-9]{4}$/));
    }
}
